<div *transloco="let t" class="flex-row flex items-center">
  <button
    class="flex items-center gap-2 p-1 rounded transition-colors hover:bg-surface-subtle disabled:hover:bg-transparent"
    [matMenuTriggerFor]="role() !== UserRole.Owner && !disabled() ? menu : null"
    [disabled]="role() === UserRole.Owner || disabled()"
    type="button"
  >
    <p class="font-medium text-ink text-sm leading-5">
      {{ UserRoleTranslationMapper.get(role()) | transloco }}
    </p>
    @if(role() !== UserRole.Owner && !disabled()){
    <img src="images/icons/chevron-down.svg" class="max-w-none w-3 h-3" [alt]="t('OPEN_DROPDOWN_MENU')" />
    }
  </button>

  <mat-menu #menu="matMenu">
    <ul class="bg-white">
      @for (role of roles()!; track role) {
      <li class="hover:bg-surface-muted">
        <button (click)="selectedValue(role)" class="text-start w-full px-4 py-2">
          {{ UserRoleTranslationMapper.get(role) | transloco }}
        </button>
      </li>
      }
    </ul>
  </mat-menu>
</div>
